//@flow
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";
import {useDebouncedCallback} from "../../../../../../hooks/useDebouncedCallback";
import ListItem from "@mui/material/ListItem";
import {TextField} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
}

const PreregistrationRedirect = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const {id, exhibition, updateExhibition} = props
    const onChange = (value) => {
        updateExhibition(id, value, Update.PreregistrationRedirect)
    }
    const {value, debouncedOnChange} = useDebouncedCallback(onChange, exhibition.preregistrationRedirect)
    return (
        <ListItem disabled={!exhibition.preregistrationEnabled}>
            <ListItemText
                primary={t("Redirection Website")}
                secondary={t("Redirect user to specific website after submitting preregistration form.")}
            />
            <TextField
                disabled={!exhibition.preregistrationEnabled}
                defaultValue={value}
                onChange={debouncedOnChange}
                size={"small"}
                variant={'filled'}
                fullWidth
                sx={{minWidth: '200px'}}
                slotProps={{
                    htmlInput: {
                        maxLength: 250,
                        inputMode: 'text'
                    },
                }}
            />
        </ListItem>
    )
}

export default PreregistrationRedirect
